/** Delay after the last keystroke before a search input fires its query. */
export const SEARCH_INPUT_DEBOUNCE_MS = 500

/** Delay before the live theme preview re-renders while a colour/font control is being dragged. */
export const THEME_PREVIEW_DEBOUNCE_MS = 200
